import { CMS_HOST, getEnvName } from '@/config'
import request from '@/service/apiConfig/request'
const originSumfsHost = CMS_HOST[getEnvName()]
/**
 * 开发平台获取列表数据
 */
export const opensums = () => {
  return request.jsonp(`${CMS_HOST[getEnvName()]}api/jsonp/opensums.jsonp`,{}, {name: 'cmsCallback'})
}

